import { render } from "./NPMRegistry.vue?vue&type=template&id=21d9aece&scoped=true"
import script from "./NPMRegistry.vue?vue&type=script&lang=js"
export * from "./NPMRegistry.vue?vue&type=script&lang=js"

import "./NPMRegistry.vue?vue&type=style&index=0&id=21d9aece&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d9aece"]])

export default __exports__